/* MonteFirme — pop-up de bienvenida + confeti de hojas de otoño. Sin dependencias. */
(function () {
  'use strict';

  var AUTUMN = ['#B5471B', '#E8631A', '#F0A030', '#F6C453', '#8C5A2B', '#6B3E1E', '#A9B24B', '#4E7A3A', '#C0392B'];

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class MFWelcomePopup extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.overlayEls = this.querySelectorAll('[data-mf-close]');
      this.dialog = this.querySelector('.mf-pop__dialog');
      this.canvas = this.querySelector('.mf-pop__confetti');
      this.copyBtn = this.querySelector('[data-mf-copy]');
      this.storageKey = this.getAttribute('data-storage-key') || 'mf-welcome';
      this.force = this.getAttribute('data-force') === 'true';
      this.delay = parseInt(this.getAttribute('data-delay'), 10) || 0;

      this._onKey = this._onKey.bind(this);

      this.overlayEls.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); this.close(); }));
      if (this.copyBtn) this.copyBtn.addEventListener('click', () => this._copy());

      if (this.force) {
        // Editor de temas: mostrar siempre para previsualizar.
        this.open();
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && this.contains(e.target)) this.open();
        });
        return;
      }

      if (this._isDismissed()) return;

      this._timer = window.setTimeout(() => this.open(), this.delay);
    }

    _isDismissed() {
      try { if (window.localStorage.getItem(this.storageKey) === '1') return true; } catch (err) {}
      try { if (window.sessionStorage.getItem(this.storageKey) === '1') return true; } catch (err) {}
      return false;
    }

    _markDismissed() {
      // Permanente: si el cliente ya lo vio o lo cerró, no vuelve a aparecer.
      try { window.localStorage.setItem(this.storageKey, '1'); } catch (err) {}
      try { window.sessionStorage.setItem(this.storageKey, '1'); } catch (err) {}
    }

    open() {
      if (this.opened) return;
      this.opened = true;
      if (!this.force) this._markDismissed();

      this.hidden = false;
      // Forzar reflow para que arranque la transición.
      void this.offsetWidth;
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);

      var closeBtn = this.querySelector('.mf-pop__close');
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); } }

      if (!reduceMotion()) this._startConfetti();
    }

    close() {
      if (!this.opened) return;
      this.opened = false;
      if (!this.force) this._markDismissed();
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this._stopConfetti();
      window.setTimeout(() => { this.hidden = true; }, 320);
    }

    _onKey(e) {
      if (e.key === 'Escape') this.close();
    }

    _copy() {
      var valueEl = this.querySelector('[data-mf-code-value]');
      var code = valueEl ? valueEl.textContent.trim() : '';
      if (!code) return;
      var done = () => {
        var original = this.copyBtn.textContent;
        this.copyBtn.textContent = this.copyBtn.getAttribute('data-copied-label') || '¡Copiado!';
        this.copyBtn.classList.add('is-copied');
        window.setTimeout(() => {
          this.copyBtn.textContent = original;
          this.copyBtn.classList.remove('is-copied');
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => this._legacyCopy(code, done));
      } else {
        this._legacyCopy(code, done);
      }
    }

    _legacyCopy(text, done) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (e) {}
    }

    /* ---------- Confeti de hojas ---------- */
    _startConfetti() {
      if (!this.canvas || !this.canvas.getContext) return;
      var canvas = this.canvas;
      var ctx = canvas.getContext('2d');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      // Confeti a pantalla completa, no solo dentro del recuadro.
      var w = window.innerWidth;
      var h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.scale(dpr, dpr);

      var count = w < 480 ? 34 : w < 900 ? 60 : 90;
      var leaves = [];
      for (var i = 0; i < count; i++) {
        // Mitad cae desde arriba, mitad sube desde abajo.
        var fromBottom = i % 2 === 0;
        leaves.push({
          x: Math.random() * w,
          y: fromBottom ? h + Math.random() * h : Math.random() * -h,
          dir: fromBottom ? -1 : 1,
          r: 4 + Math.random() * 7,
          color: AUTUMN[(Math.random() * AUTUMN.length) | 0],
          vy: 1.3 + Math.random() * 2.1,
          vx: -0.8 + Math.random() * 1.6,
          rot: Math.random() * Math.PI * 2,
          vr: -0.08 + Math.random() * 0.16,
          sway: Math.random() * 2 + 1
        });
      }

      var start = performance.now();
      var DURATION = 6200;
      var self = this;

      function frame(now) {
        var elapsed = now - start;
        ctx.clearRect(0, 0, w, h);
        var fade = elapsed > DURATION - 900 ? Math.max(0, (DURATION - elapsed) / 900) : 1;

        for (var k = 0; k < leaves.length; k++) {
          var p = leaves[k];
          p.y += p.vy * p.dir;
          p.x += p.vx + Math.sin((p.y + p.sway * 40) / 40) * 0.5;
          p.rot += p.vr;

          ctx.save();
          ctx.globalAlpha = fade;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.beginPath();
          ctx.ellipse(0, 0, p.r, p.r * 0.6, 0, 0, Math.PI * 2);
          ctx.fill();
          ctx.strokeStyle = 'rgba(0,0,0,0.12)';
          ctx.lineWidth = 0.6;
          ctx.beginPath();
          ctx.moveTo(-p.r, 0);
          ctx.lineTo(p.r, 0);
          ctx.stroke();
          ctx.restore();

          if (p.dir === 1 && p.y > h + 20) { p.y = -10; p.x = Math.random() * w; }
          else if (p.dir === -1 && p.y < -20) { p.y = h + 10; p.x = Math.random() * w; }
        }

        if (elapsed < DURATION && self.opened) {
          self._raf = requestAnimationFrame(frame);
        } else {
          ctx.clearRect(0, 0, w, h);
        }
      }
      this._raf = requestAnimationFrame(frame);
    }

    _stopConfetti() {
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this.canvas && this.canvas.getContext) {
        var c = this.canvas.getContext('2d');
        c.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }
    }
  }

  if (!customElements.get('mf-welcome-popup')) {
    customElements.define('mf-welcome-popup', MFWelcomePopup);
  }
})();
